import { AdvanceProps } from '../../Pages/BalanceAdvance'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { formatDecimal } from '../../utils/withdraw-helpers'

export interface useWithdrawProps {
  fetcher: (id: string) => Promise<any>
}

export const useAdvanceSimulation = (id: string | undefined, payload: AdvanceProps) => {
    const url: string = 'producer/analytics/balanceAdvanceSimulation'

    const useAdvanceSimulationFetcher = async () => { 
      const nWithdrawMoney = payload.totalAdvancedRequested.replace(',', '.')
      const formattedWithdrawMoney = formatDecimal(nWithdrawMoney)
      payload.totalAdvancedRequested = formattedWithdrawMoney

      return await APIDecoratorWithBaseURI().post(url,
        {
          params: {
        eventId: id,
        ...payload,
        }
      }) 
    }
    
    return {
      useAdvanceSimulationFetcher
    }
}


